import React from 'react'
import PropTypes from 'prop-types'
import {makeStyles, useTheme} from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import TableHead from "@material-ui/core/TableHead"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import {timeFormatter2, brushValue} from "../fncomponents/UISupportFns"
import c from "../../constants";

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, columns } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map(column => (
                    <TableCell
                        key={column.id}
                        align={column.numeric ? 'right' : 'left'}
                        padding={'default'}
                        sortDirection={orderBy === column.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === column.id}
                            direction={order}
                            onClick={createSortHandler(column.id)}
                        >
                            {column.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
}
const useStyles1 = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5),
    },
}))

function TablePaginationActions(props) {
    const classes = useStyles1()
    const theme = useTheme()
    const { count, page, rowsPerPage, onChangePage } = props

    function handleFirstPageButtonClick(event) {
        onChangePage(event, 0)
    }

    function handleBackButtonClick(event) {
        onChangePage(event, page - 1)
    }

    function handleNextButtonClick(event) {
        onChangePage(event, page + 1)
    }

    function handleLastPageButtonClick(event) {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    )
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
}

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
}))

export default function BotsEnhancedTable(props) {
    const {columns, rows, rowsPerPage, setRowsPerPage, page, setPage, totalDocs,
        filtersMap, onFilterChange, editBot, stopBot} = props
    const classes = useStyles()
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('value')
    const botActionType = {[c.ACTION_TYPE_BUY]: 'Starts with a Buy', [c.ACTION_TYPE_SELL]: 'Starts with a Sell'}


    function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === 'desc'
        setOrder(isDesc ? 'asc' : 'desc')
        setOrderBy(property)
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalDocs - page * rowsPerPage)

    function handleChangePage(event, newPage) {
        setPage(newPage)
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                    >
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            columns={columns}
                        />
                        <TableBody>
                            {(rows && rows.length > 0) && rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                                let stopTargetTitle = row.stopLossTarget.reached ? "Reached": ""
                                return (<TableRow hover tabIndex={0} key={`row_${row._id}`}>
                                    <TableCell component="th" scope="row" key={`row_${row._id}_signal`}>
                                        <div style={{opacity: "0.8", border:"1px solid gray", padding: "1rem", width: "22rem", backgroundColor: "#1A222F"}}>
                                            <div style={{display: "flex", justifyContent: "flex-start"}}>
                                                <div>
                                                    <span style={{fontSize: "1.2rem"}}>{row.quoteAsset}</span>/<span style={{fontSize: "1.2rem"}}>{row.baseAsset}</span>
                                                </div>
                                                <div style={{marginLeft:"1rem"}}>
                                                    {row.status === c.BOT_STATUS_ACTIVE && <span className="blink live" style={{color: "#68FF7D"}}>▶</span>}
                                                    {row.status === c.BOT_STATUS_STOPPED && <span className="live" style={{color: "#FE484F"}}>◼</span>}
                                                </div>
                                            </div>
                                            <div style={{fontSize: "0.8rem", opacity: "0.8"}}>({botActionType[row.actionType]})</div>
                                            <div style={{fontWeight: "bold"}} title={stopTargetTitle}>Pos. size {row.posSize}</div>
                                            <div>Last command <b>{row.lastCommand}</b> on <b>{row.lastTradeId}</b> at <b>{timeFormatter2(row.lastCommandTime, true)}</b></div>
                                            {row.lastCommandError && <div style={{marginLeft: "1rem"}}>error <span style={{color: "#FB4A4A"}}>{row.lastCommandError}</span></div>}
                                            <div style={{fontWeight: "bold"}} title={stopTargetTitle}>
                                                SL target: {row.stopLossOption === c.STOP_LOSS_OPTION_PERCENTAGE && <span>-</span>}{brushValue(row.stopLossTarget)}{row.stopLossOption === c.STOP_LOSS_OPTION_PERCENTAGE &&
                                            <span>%</span>}
                                            </div>
                                            <div style={{fontSize: "0.8rem", opacity: "0.8", display: "flex", justifyContent: "space-between", width: "20rem", marginTop: "1rem"}}>
                                                    <div>{row.id}</div>
                                                <div>{timeFormatter2(row.creationDate, true)}</div>
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell align="left" key={`row_${row._id}_actions`}>
                                       <div style={{display: "flex", justifyContent: "space-between", width: "5rem"}}>
                                           {editBot && <div className={"hrefButton"} style={{verticalAlign: "middle", height: "1rem", position: "relative", textAlign: "left"}}>
                                                <span onClick={()=>{editBot(row._id)}} style={{marginLeft: "0.8rem"}}>Edit</span>&nbsp;&nbsp;
                                            </div>}
                                           {stopBot && <div className={"hrefButton"} style={{verticalAlign: "middle", height: "1rem", position: "relative", textAlign: "left"}}>
                                                <span onClick={()=>{stopBot(row._id)}} style={{marginLeft: "0.8rem"}}>Stop</span>
                                            </div>}
                                       </div>
                                    </TableCell>
                                </TableRow>)
                            })
                            }
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    colSpan={6}
                                    count={totalDocs}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: { 'aria-label': 'rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        </div>
    )
}
